/**
 * Created by henian.xu on 2019/10/13.
 *
 */

import Vue from 'vue';
import Vuex, { Module, ModuleOptions } from 'vuex';
import { assert, hasOwn } from '@vmf/shared';
import { gettersPlugin } from './plugins';

// import Global from './Global'; // 移到 vmf 模块下

Vue.use(Vuex);

function assertModule(store: any, path: string | string[]) {
    const pathList: string[] = Array.isArray(path) ? path : [path];

    for (let i: number = 0, len: number = pathList.length; i < len; i += 1) {
        const key = pathList[i];
        if (!hasOwn(store, key)) return;
        store = store[key];
    }
    assert(false, `${pathList.join('.')} 模块/属性已经存在，所以不能注册!`, '@vmf/vuex');
}

export const store = new Vuex.Store({
    plugins: [gettersPlugin],
    // 原始默认状态(是无法被 unregisterModule 注销的)
    modules: {},
    state: {},
    getters: {},
    mutations: {},
    actions: {},
});

export function registerModule<T, S>(
    path: string | string[],
    module: Module<T, typeof store.state>,
    options?: ModuleOptions,
): void {
    assertModule(store.state, path);
    store.registerModule(path as string & string[], module, options);
    const rootModule = (store as any)._modules.root;
    const { plugins } = rootModule._rawModule;
    // apply plugins
    plugins.forEach((plugin: any) => plugin(store));
}

export function unregisterModule(path: string | string[]): void {
    store.unregisterModule(path as string & string[]);
}
